import { multiRoomRateAddToBasket, roomRateAddToBasket } from '@store/basket/actions';
import { basketSelectors } from '@store/basket/selectors';
import { entitySelectors } from '@store/entity/selectors';
import { yourJourneySelectors } from '@store/yourJourney/selectors';
import { connect } from 'react-redux';
import { destroy, reset } from 'redux-form';
import { RoomRateConfigurationWizard } from './RoomRateConfigurationWizard';
import {
  RoomRateConfigurationWizardDispatchProps,
  RoomRateConfigurationWizardStoreProps,
} from './RoomRateConfigurationWizard.types';
import { multiRoomRateBookingFormConfig, roomRateBookingFormConfig } from './shared';

const mapStateToProps = (state): RoomRateConfigurationWizardStoreProps => ({
  basketGuests: basketSelectors.getBasketGuests(state),
  journeyParams: yourJourneySelectors.getParsedJourneyParams(state),
  isFetching: basketSelectors.getIsBasketDetailsFetching(state),
  property: entitySelectors.getProperty(state),
  basketDetails: basketSelectors.getBasketDetails(state),
});

const mapDispatchToProps = (dispatch): RoomRateConfigurationWizardDispatchProps => ({
  roomRateAddToBasket: roomRateAddToBasket(dispatch),
  multiRoomRateAddToBasket: multiRoomRateAddToBasket(dispatch),
  reset: () => {
    dispatch(reset(roomRateBookingFormConfig.form));
    dispatch(reset(multiRoomRateBookingFormConfig.form));
  },
  destroy: () => dispatch(destroy),
});

export const RoomRateConfigurationWizardConnected: any = connect(
  mapStateToProps,
  mapDispatchToProps
)(RoomRateConfigurationWizard);
